<div id="dept-economics" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Department of Economics</h2>
    <p class="inner-lead mt-3">
      The Department of Economics at Shah Satnam Ji Girls' College, Sirsa offers a comprehensive study of economic theories, policies and their real-world applications. The department nurtures students to think critically about economic issues at local, national and global levels.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Courses Offered</h4>
    <ul class="inner-lead">
      <li>Economics as a subject in BA</li>
    </ul>

    <hr class="divider">

    <h4 class="section-subtitle">Faculty</h4>
    <div class="table-responsive-inner mt-3">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Qualification</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1</td><td>Dr. Pooja Monga</td><td>MA, M.Com, MBA, Ph.D</td></tr>
        </tbody>
      </table>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Department Activities</h4>
    <ul class="inner-lead">
      <li>Career Counselling Seminar</li>
      <li>Union Budget Discussion Session</li>
      <li>Poverty Eradication Day Events</li>
    </ul>

  </div>
</div>
